export default __webpack_public_path__ + "static/cross-lines-074c0d0cab2d5066deb08f8bbc902cf6.png";